import { Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const CANDIDATE_STATUS_STYLES = {
    initialized:            { bg: "gray.100",   borderColor: "gray.200",   color: "gray.700" },
    created:                { bg: "blue.100",   borderColor: "blue.200",   color: "blue.700" },
    finalized:              { bg: "orange.100", borderColor: "orange.200", color: "orange.700" },
    qualifiedfornextstage:  { bg: "purple.100", borderColor: "purple.200", color: "purple.700" },
    furtherselection:       { bg: "cyan.100",   borderColor: "cyan.200",   color: "cyan.700" },
    readytohire:            { bg: "teal.100",   borderColor: "teal.200",   color: "teal.700" },
    hired:                  { bg: "green.100",  borderColor: "green.200",  color: "green.700" },
    rejected:               { bg: "red.100",    borderColor: "red.200",    color: "red.700" },
    candidateresigned:      { bg: "gray.100",   borderColor: "gray.200",   color: "gray.700" },
};

const DEFAULT_STYLE = { bg: "gray.100", borderColor: "gray.200", color: "gray.700" };

const CandidateStatusBadge = ({ status }) => {
    const { t } = useTranslation("models");
    const key = status?.toLowerCase() ?? "initialized";
    const style = CANDIDATE_STATUS_STYLES[key] ?? DEFAULT_STYLE;
    return (
        <Badge
            bg={style.bg}
            borderColor={style.borderColor}
            borderWidth={1}
            variant="subtle"
            fontSize="xs"
            px={3}
            py={0.5}
            borderRadius={6}
            color={style.color}
        >
            {t(`candidateStatus.${key}`)}
        </Badge>
    );
};

export default CandidateStatusBadge;
